import { defineStore } from 'pinia'
import obfn from '@/utils/obfn'

const firstDate = obfn.getFirstDayOfYear()
const curDate = obfn.getCurDate()

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      userName: 'Anonymous',
      email: 'null@gmail.com',
      role: {},
      memberSince: '8/12/2020',
      is2FAEnabled: false,
      token: '',
      remeberMe: false,
      locale: 'cn',
      dashboardDate: {
        startDate: firstDate,
        endDate: curDate,
      },
    }
  },
  actions: {
    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },
    changeUserName(userName: string) {
      this.userName = userName
    },
    changeEmail(email: string) {
      this.email = email
    },
    changeRole(role: object) {
      this.role = role
    },
    tokenSet(val: string) {
      this.token = val
    },
    tokenSetExpired() {
      this.token = ''
    },
  },
  persist: true,
})
